<form #liveSearchForm="ngForm">
  <input name="liveSearch"
    [placeholder]="placeholder"
    [formControl]="liveSearchControl"
    [matAutocomplete]="auto">
  <mat-autocomplete
    #auto="matAutocomplete"
    [displayWith]="formatSelected"
    (optionSelected)="onOptionSelected($event)">
    @for (item of searchResults$ | async; track item.key) {
      <mat-option
        class="live-search-result"
        [value]="item">
        @for (resultRow of item.display; track resultRow) {
          <span class="live-search-result-row">
            {{ resultRow }}
          </span>
        }
      </mat-option>
    }
  </mat-autocomplete>
</form>
